import { css } from "styled-components";
export const easings = {
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeInOutCubic: [0.65, 0, 0.35, 1],
};

export const fill = (pos: "absolute" | "fixed" = "absolute") => css`
  position: ${pos};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

// export const imgFill = (object) => css`

// `;
